import {Injectable} from "@angular/core";
import {Actions, createEffect, Effect, ofType} from "@ngrx/effects";
import {DictionaryService} from "../../services/dictionary.service";
import {IAppState} from "../../state/app.state";
import {Store} from "@ngrx/store";
import {EMDMActions, FinishStageMdmLoadingProgression, LoadHierarchyDetail, LoadHierarchyDetailFailure, LoadHierarchyDetailSuccess, LoadHierarchyLevels, LoadHierarchyLevelsFailure, LoadHierarchyLevelsSuccess, LoadHierarchyList, LoadHierarchyListFailure, LoadHierarchyListSuccess, LoadTypes, LoadTypesFailure, LoadTypesSuccess, StartMdmLoadingProgression} from "../../actions/mdm/mdm.actions";
import {catchError, map, mergeMap, switchMap, tap, withLatestFrom} from "rxjs/operators";
import {of} from "rxjs";
import {emptyMDMElement, emptyMDMElementProfile, emptyMDMHierarchyProfile, emptyMDMType, emptyMDMTypeProfile, IMDMHierarchy, IMDMLevel, IMDMType} from "@retail-data-factory/rdf-angular-types-api";
import {logger} from "@retail-data-factory/rdf-angular-utils";
import {MessageService} from "@retail-data-factory/rdf-angular-messages";
import {TranslateService} from "@ngx-translate/core";
import {LoggerService} from "../../../../services/external-api/logger.service";
import {Logout} from "../../actions/security/authentication.actions";
import {ApiMdmService} from "../../../../api/external/api-services/api-mdm/api-mdm.service";
import {SpinnerService} from "@retail-data-factory/rdf-angular-utils";
import {SpinnerParams} from "@retail-data-factory/rdf-angular-utils";

@Injectable()
export class MdmEffects {
  loadedCnt = 0;


  InitMdmStore$ = createEffect(() => this._actions$.pipe(
    ofType<LoadTypesSuccess>(EMDMActions.InitMDMStore),
    withLatestFrom(this._store$),
    // switchMap(()=>{
    //   return of(new LoadTypes());
    // })
    tap(([action, storeState]) => {
        logger.print('InitMDMStore started', 'info');
        this.spinnerService.show('titled', {title: this.translateService.instant('mdm.messages.dictLoading'), disableButton: true});
        this._store$.dispatch(new LoadTypes());
        logger.print('InitMDMStore finished', 'info');
      }
    )
  ), {dispatch: false});


  Types$ = createEffect(() => this._actions$.pipe(
    ofType<LoadTypes>(EMDMActions.LoadTypes),
    withLatestFrom(this._store$),
    switchMap(([action, storeState]) => {
        return this._service.getTypes(
          storeState.authentication.data.accessToken,
          storeState.applicationParameters.selectedDatasourcePartyId
        ).pipe(
          map(
            result => {
              //            this.spinnerService.show('titled', {title: this.translateService.instant('mdm.messages.dictLoading'), disableButton: true});
              this.loadedCnt = 0;
              logger.print('LoadTypes started', 'info');
              if (result['Error'] === 0) {
                const types: Array<IMDMType> = [];
                result['report'].forEach((element) => {
                  if (element['type_code'] !== '1RED_OSA_INCIDENT_TYPE' /*&& environment.realm!=='auchan_ua'*/) {
                    types.push({
                      ...emptyMDMType,
                      ownerPartyId: element['party_id'],
                      code: element['type_code'],
                      name: element['type_name'],
                      description: element['type_description'],
                      isDefault: element['is_default'] === 1,
                      isHierarchyPresent: element['is_hierarchy_present'] === null || element['is_hierarchy_present'] === undefined || element['is_hierarchy_present'] === 1,
                      profile: {...emptyMDMTypeProfile, ...element['profile']},
                    });
                  }
                });
                logger.print('LoadTypes finished', 'info');
                return new LoadTypesSuccess(types);
              } else {
                this.errorMessage('dictLoadingError', 'LoadTypes', result['Error'], result['Msg']);
                return new LoadTypesFailure();

              }
            }
          ),
          catchError(error => {
            this.errorMessage('dictLoadingError', 'LoadTypes', -1, JSON.stringify(error));
            logger.print('LoadTypes effect error', 'error');
            console.log(error);
            if (error['status'] === 401) {
              this.spinnerService.hide('titled');
              this._store$.dispatch(new Logout());//
            }
            return of(new LoadTypesFailure());
          })
        );
      }
    )
  ));

  LoadTypesSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<LoadTypesSuccess>(EMDMActions.LoadTypesSuccess),
    withLatestFrom(this._store$),
    tap(([action, storeState]) => {
        logger.print('LoadTypesSuccess started', 'info');

        //const ar:Array<{typeCode: string}> = [];
        const dictCnt = storeState.mdm.types.filter(t => t.isHierarchyPresent).length;
        this._store$.dispatch(new StartMdmLoadingProgression({stages: dictCnt}));
        this.spinnerService.show('titled', {title: `${this.translateService.instant('mdm.messages.dictLoading')}: 0 ${this.translateService.instant('mdm.messages.of')} ${dictCnt}`, disableButton: true});

        storeState.mdm.types
          .filter(t => t.isHierarchyPresent)
          .forEach((type) => {
            //if (type.code === 'RED_NOMENCLATURE') {
            logger.print('LoadTypesSuccess effect. Dispatching LoadHierarchyList for typeCode = ' + type.code, 'info');

            this._store$.dispatch(new LoadHierarchyList({typeCode: type.code}));
            //ar.push({typeCode: type.code});
            //}
          });
        if (dictCnt === 0 ) {
          this._store$.dispatch(new FinishStageMdmLoadingProgression());
        }
        //this._store$.dispatch(new LoadAllHierarchy(ar));
        logger.print('LoadTypesSuccess finished', 'info');
      }
    )
  ), {dispatch: false});


  // AllHierarchy$ = this._actions$.pipe(
  //   ofType<LoadAllHierarchy>(EMDMActions.LoadAllHierarchy),
  //   withLatestFrom(this._store$),
  //   switchMap(([action, storeState]) =>{
  //       return forkJoin([
  //           this._service.getHierarchyList(storeState.authentication.data.accessToken, 'RED_NOMENCLATURE', storeState.applicationParameters.selectedDatasourcePartyId),
  //           this._service.getHierarchyList(storeState.authentication.data.accessToken, 'RED_ORGANISATION', storeState.applicationParameters.selectedDatasourcePartyId),
  //           this._service.getHierarchyList(storeState.authentication.data.accessToken, 'RED_SUPPLIERS', storeState.applicationParameters.selectedDatasourcePartyId),
  //           this._service.getHierarchyList(storeState.authentication.data.accessToken, 'RED_TIME', storeState.applicationParameters.selectedDatasourcePartyId)
  //         ]
  //
  //       ).pipe(
  //         map(
  //           result =>{
  //             logger.print('LoadAllHierarchy started', 'info');
  //             const hierarchyList: Array<IMDMHierarchy> = [];
  //
  //             if (result['Error']===0) {
  //               result.forEach((data) => {
  //                 data['report'].forEach((element) => {
  //                   hierarchyList.push(
  //                     {
  //                       id: element['hier_id'],
  //                       code: element['hier_code'],
  //                       name: element['hier_name'],
  //                       description: element['hier_description'],
  //                       type: storeState.mdm.types.find(item => item.code === element['type_code']),
  //                       isDefault: element['is_default'] === 1,
  //                       levels: [],
  //                       profile: element['profile']
  //                     }
  //                   );
  //                 });
  //               });
  //             }else{
  //               this.errorMessage('dictLoadingError', 'LoadAllHierarchy', result['Error'], result['Msg']);
  //             }
  //             logger.print('LoadAllHierarchy effect finished', 'info');
  //
  //             return new LoadAllHierarchySuccess(hierarchyList);
  //
  //           }
  //         ),
  //         catchError(error =>{
  //           this.errorMessage('dictLoadingError','LoadAllHierarchy',-1, JSON.stringify(error));
  //
  //           logger.print('LoadAllHierarchy effect error', 'error');
  //             console.log(error);
  //             if(error['status']===401) {
  //               this._userService.logout().catch(err=>{
  //                 logger.error('Logout from LoadAllHierarchy effect error!');
  //                 console.log(err);
  //               });
  //             }
  //             return of(new LoadHierarchyListFailure());
  //           }
  //         )
  //       );
  //     }
  //   )
  // );


  hierarchyLists$ = createEffect(() => this._actions$.pipe(
    ofType<LoadHierarchyList>(EMDMActions.LoadHierarchyList),
    withLatestFrom(this._store$),
    mergeMap(([action, storeState]) => {
        return this._service.getHierarchyList(
          storeState.authentication.data.accessToken,
          action.payload.typeCode,
          storeState.applicationParameters.selectedDatasourcePartyId
        ).pipe(
          map(
            result => {
              logger.print('LoadHierarchyList for type ' + action.payload.typeCode + ' effect started', 'info');

              const hierarchyList: Array<IMDMHierarchy> = [];
              if (result['Error'] === 0) {
                result['report'].forEach((element) => {
                  const hier: IMDMHierarchy = {
                    id: element['hier_id'],
                    code: element['hier_code'],
                    name: element['hier_name'],
                    description: element['hier_description'],
                    type: storeState.mdm.types.find(item => item.code === element['type_code']),
                    isDefault: element['is_default'] === 1,
                    levels: [],
                    profile: {...emptyMDMHierarchyProfile, ...element['profile']}
                  };
                  if (typeof hier.profile.param['lowest_level'] === 'string') {
                    hier.profile.param.lowest_level = parseInt(hier.profile.param.lowest_level, 10);
                  }
                  hierarchyList.push(hier);


                });
              } else {
                this.errorMessage('dictLoadingError', 'LoadHierarchyList', result['Error'], result['Msg']);

              }
              logger.print('LoadHierarchyList effect for type ' + action.payload.typeCode + 'finished', 'info');

              return new LoadHierarchyListSuccess(hierarchyList);
            }
          ),
          catchError(error => {
              this.errorMessage('dictLoadingError', 'LoadHierarchyList', -1, JSON.stringify(error));

              logger.print('LoadHierarchyList effect error', 'error');
              console.log(error);
              if (error['status'] === 401) {
                this._store$.dispatch(new Logout());//

              }
              return of(new LoadHierarchyListFailure());
            }
          )
        );
      }
    )
  ));
  hierarchyListsSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<LoadHierarchyListSuccess>(EMDMActions.LoadHierarchyListSuccess),
    withLatestFrom(this._store$),
    tap(([action, storeState]) => {
        logger.print('LoadHierarchyListSuccess effect started', 'info');
        if (action.payload.length === 0) {
          this._store$.dispatch(new FinishStageMdmLoadingProgression());
        }
        action.payload.forEach((item) => {
          logger.print('LoadHierarchyListSuccess effect. Dispatching LoadHierarchyLevels for typeCode = ' + item.type.code + ' and hierCode = ' + item.id, 'info');
          this._store$.dispatch(new LoadHierarchyLevels({typeCode: item.type.code, hierCode: item.id}));
        });
        //this._store$.dispatch(new LoadAllHierarchy(ar));
        logger.print('LoadHierarchyListSuccess effect finished', 'info');
      }
    )
  ), {dispatch: false});

  hierarchyLevels$ = createEffect(() => this._actions$.pipe(
    ofType<LoadHierarchyLevels>(EMDMActions.LoadHierarchyLevels),
    withLatestFrom(this._store$),
    mergeMap(([action, storeState]) => {
        return this._service.getHierarchyLevels(
          storeState.authentication.data.accessToken,
          action.payload.typeCode,
          action.payload.hierCode,
          storeState.applicationParameters.selectedDatasourcePartyId
        ).pipe(
          map(
            result => {
              logger.print('LoadHierarchyLevels effect for type ' + action.payload.typeCode + ' and hier code ' + action.payload.hierCode + '  started', 'info');

              const levels: Array<IMDMLevel> = [];
              if (result['Error'] === 0) {
                result['report'].forEach((element) => {
                  levels.push(
                    {
                      id: element['level_id'] !== null && element['level_id'] !== undefined ? element['level_id'].toString() : '',
                      levelNum: element['level_num'] !== null && element['level_num'] !== undefined ? element['level_num'].toString() : '',
                      levelParentId: element['level_parent_id'] !== null && element['level_parent_id'] !== undefined ? element['level_parent_id'].toString() : '',
                      code: element['level_code'],
                      name: element['level_name'],
                      description: element['level_description'],
                      elements: [],
                      profile: element['profile'],
                    }
                  );

                });
              } else {
                this.errorMessage('dictLoadingError', 'LoadHierarchyLevels', result['Error'], result['Msg']);

              }
              logger.print('LoadHierarchyLevels effect for type ' + action.payload.typeCode + ' and hier code ' + action.payload.hierCode + ' finished', 'info');
              return new LoadHierarchyLevelsSuccess({hierTypeCode: action.payload.typeCode, hierCode: action.payload.hierCode, levels});
            }
          ),
          catchError(error => {
              this.errorMessage('dictLoadingError', 'LoadHierarchyLevels', -1, JSON.stringify(error));

              logger.print('LoadHierarchyLevels effect error', 'error');
              console.log(error);
              if (error['status'] === 401) {
                this._store$.dispatch(new Logout());//

              }
              return of(new LoadHierarchyLevelsFailure());
            }
          )
        );
      }
    )
  ));


  hierarchyLevelsSuccess$ = createEffect(() => this._actions$.pipe(
    ofType<LoadHierarchyListSuccess>(EMDMActions.LoadHierarchyLevelsSuccess),
    withLatestFrom(this._store$),
    mergeMap(([action, storeState]) => {
        logger.print('LoadHierarchyLevelsSuccess effect started', 'info');
        console.log(action);
        console.log(storeState.mdm.hierarchy);
        const hier: IMDMHierarchy = storeState.mdm.hierarchy.find(item => item.id === action.payload['hierCode']);
        //this.errorMessage('dictLoadingError', 'LoadHierarchyLevelsSuccess', -1, 'LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found');
        if (!hier) {
          logger.print('LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found', 'error');
          this.errorMessage('dictLoadingError', 'LoadHierarchyLevelsSuccess', -1, 'LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found');
          return of(new LoadHierarchyLevelsFailure());
        }
        let levelCode = -1;
        if (hier.profile['param']) {
          levelCode = hier.profile['param']['lowest_level'];
          if (!hier.profile['param']['auto_load_lowest_level']) {
            levelCode -= 1;
          }
        }
        const param = {
          typeCode: hier.type.code,
          hierCode: hier.id,
          levelCode: levelCode.toString()
        };
        console.log('Dispatching  LoadHierarchyDetail with params:');
        console.log(param);
        return of(new LoadHierarchyDetail(param));
        //this._store$.dispatch(new LoadHierarchyDetail(param));


        logger.print('LoadHierarchyLevelsSuccess effect finished', 'info');
      }
    )
  ));


  /*
  hierarchyLevelsSuccess$ = this._actions$.pipe(
    ofType<LoadHierarchyListSuccess>(EMDMActions.LoadHierarchyLevelsSuccess),
    withLatestFrom(this._store$),
    tap( ([action,storeState]) => {
        logger.print('LoadHierarchyLevelsSuccess effect started', 'info');
        console.log(action);
        console.log(storeState.mdm.hierarchy);
        const hier:IMDMHierarchy = storeState.mdm.hierarchy.find(item => item.id === action.payload['hierCode']);
        //this.errorMessage('dictLoadingError', 'LoadHierarchyLevelsSuccess', -1, 'LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found');
        if (!hier) {
          logger.print('LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found', 'error');
          //this.errorMessage('dictLoadingError', 'LoadHierarchyLevelsSuccess', -1, 'LoadHierarchyLevelsSuccess effect failed. hier with code ' + action.payload['hierCode'] + ' not found');
          return;
        }
        let levelCode = -1;
        if (hier.profile['param']) {
          levelCode = hier.profile['param']['lowest_level'];
          if (!hier.profile['param']['auto_load_lowest_level']) {
            levelCode -= 1;
          }
        }
        const param = {
          typeCode:hier.type.code,
          hierCode: hier.id,
          levelCode:levelCode.toString()
        };
        console.log('Dispatching  LoadHierarchyDetail with params:');
        console.log(param);
        //this._store$.dispatch(new LoadHierarchyDetail(param));


        logger.print('LoadHierarchyLevelsSuccess effect finished', 'info');
      }
    )

  );
*/

  hierarchyDetail$ = createEffect(() => this._actions$.pipe(
    ofType<LoadHierarchyDetail>(EMDMActions.LoadHierarchyDetail),
    withLatestFrom(this._store$),
    mergeMap(([action, storeState]) => {
        return this._service.getHierarchyDetail(
          storeState.authentication.data.accessToken,
          action.payload.typeCode,
          action.payload.hierCode,
          action.payload.levelCode,
          storeState.applicationParameters.selectedDatasourcePartyId
        ).pipe(
          map(
            result => {
              if (result['Error'] === 0) {
                this.loadedCnt = this.loadedCnt + 1;
                const spinnerParams: SpinnerParams = {
                  type: 'titled',
                  data: {title: `${this.translateService.instant('mdm.messages.dictLoading')}: ${this.loadedCnt} ${this.translateService.instant('mdm.messages.of')} ${storeState.mdm.types.filter(t=>t.isHierarchyPresent).length}`, disableButton: true}
                };
                this.spinnerService.spinnerParams.next(spinnerParams);

                logger.print('LoadHierarchyDetail effect started', 'info');

                //найти иерархию для которой грузим данные
                const hierarchy = storeState.mdm.hierarchy.find(item => item.type.code === action.payload.typeCode && item.id === action.payload.hierCode);

                if (!hierarchy) {
                  logger.print('LoadHierarchyDetail effect failure -> hierarchy with code ' + action.payload.hierCode + ' not found', 'error');
                  this.errorMessage('dictLoadingError', 'LoadHierarchyDetail', -1, 'LoadHierarchyDetail effect failure -> hierarchy with code ' + action.payload.hierCode + ' not found');
                  return new LoadHierarchyDetailFailure();
                }
                const levels = hierarchy.levels;
                const levelCode: number = parseInt(action.payload.levelCode, 10);
                if (hierarchy.levels.length === 0) {
                  logger.print('LoadHierarchyDetail effect failure -> hierarchy with code ' + action.payload.hierCode + ' was founded, but levels = 0', 'error');
//                  this.errorMessage('dictLoadingError', 'LoadHierarchyDetail', -1, 'LoadHierarchyDetail effect failure -> hierarchy with code ' + action.payload.hierCode + ' was founded, but levels = 0');
                  this._store$.dispatch(new FinishStageMdmLoadingProgression());

                  return new LoadHierarchyDetailSuccess(null);
//                  return new LoadHierarchyDetailFailure();

                }
                for (let i = 0; i < levelCode; i++) {
                  levels[i].elements = [];
                }
                result['report'].forEach((item) => {
                  for (let i = 0; i < (levelCode - 1); i++) {
                    const idx = levels[i].elements.findIndex(elem => elem.code === item['level_' + (i + 1) + '_code']);
                    if (idx === -1) {
                      if (item['level_' + (i + 1) + '_id'] ? item['level_' + (i + 1) + '_id'].toString() : item['level_' + (i + 1) + '_code']) {
                        levels[i].elements.push(
                          {
                            ...emptyMDMElement,
                            rawData: item,
                            id: item['level_' + (i + 1) + '_id'] ? item['level_' + (i + 1) + '_id'].toString() : item['level_' + (i + 1) + '_code'],
                            code: item['level_' + (i + 1) + '_code'],
                            name: item['level_' + (i + 1) + '_name'],
                            description: item['level_' + (i + 1) + '_desc'],
                            parentId: i === 0 ? '' : item['level_' + (i) + '_id'] ? item['level_' + (i) + '_id'].toString() : item['level_' + (i) + '_code'],
                            parentCode: i === 0 ? '' : item['level_' + (i) + '_code'],
                            parentName: i === 0 ? '' : item['level_' + (i) + '_name'],
                            parents: this.apiMdmService.getParentsFromItem(item, i),
                            profile: {...emptyMDMElementProfile, ...item['level_' + (i + 1) + '_profile']}
                          }
                        );
                      }
                    }
                  }
                  if (item['level_' + item['max_level_num'] + '_id'] ? item['level_' + item['max_level_num'] + '_id'].toString() : item['level_' + item['max_level_num'] + '_code']) {
                    levels[item['max_level_num'] - 1].elements.push(
                      {
                        ...emptyMDMElement,
                        rawData: item,
                        id: item['level_' + item['max_level_num'] + '_id'] ? item['level_' + item['max_level_num'] + '_id'].toString() : item['level_' + item['max_level_num'] + '_code'],
                        code: item['level_' + item['max_level_num'] + '_code'],
                        name: item['level_' + (item['max_level_num']) + '_name'],
                        description: item['level_' + item['max_level_num'] + '_desc'],
                        parentId: item['max_level_num'] === 1 ? '' : item['level_' + (item['max_level_num'] - 1) + '_id'] ? item['level_' + (item['max_level_num'] - 1) + '_id'].toString() : item['level_' + (item['max_level_num'] - 1) + '_code'],
                        parentCode: item['max_level_num'] === 1 ? '' : item['level_' + (item['max_level_num'] - 1) + '_code'],
                        parentName: item['max_level_num'] === 1 ? '' : item['level_' + (item['max_level_num'] - 1) + '_name'],
                        parents: this.apiMdmService.getParentsFromItem(item, parseInt(item['max_level_num'], 10) - 1),
                        profile: {...emptyMDMElementProfile, ...item['level_' + item['max_level_num'] + '_profile']}
                      }
                    );
                  }
                });
                //загрузить данные в уровни этой иерархии
                //вернуть эти уровни чтобы редюсер вставил их в иерархию
                logger.print('LoadHierarchyDetail effect finished', 'info');
                this._store$.dispatch(new FinishStageMdmLoadingProgression());
                return new LoadHierarchyDetailSuccess({hierTypeCode: action.payload.typeCode, hierCode: action.payload.hierCode, levels});
              } else {
                this.errorMessage('dictLoadingError', 'LoadHierarchyDetail', result['Error'], result['Msg']);

                return new LoadHierarchyDetailFailure();

              }
            }
          ),
          catchError(error => {
              this.errorMessage('dictLoadingError', 'LoadHierarchyDetail', -1, JSON.stringify(error));

              logger.print('LoadHierarchyDetail effect error', 'error');
              console.log(error);
              if (error['status'] === 401) {
                this._store$.dispatch(new Logout());//

              }
              return of(new LoadHierarchyDetailFailure());
            }
          )
        );
      }
    )
  ));

  errorMessage(text: string, stage: string, rdfErrorCode: number, error: string) {
    this.messageService.errorDialog.text1 = 'Retail Data Factory';
    this.messageService.errorDialog.text2 = this.translateService.instant(`mdm.errors.${text}`);
    this.messageService.errorDialog.onBtnClick = (btn) => {
      this._store$.dispatch(new Logout());
      //window.location.reload(true);
    };
    /*
      log(method: string, stage: string, parameters: string, description:string, message: string, type: typeOptions, code: string, execTime: string){

     */
    this.loggerService.log('MDMEffect', stage, {}, '', error, 'ERROR', rdfErrorCode.toString(), '0');

    this.messageService.open('error');
  }


  finishStageMdmLoadingProgression$ = createEffect(() => this._actions$.pipe(
    ofType<LoadTypesSuccess>(EMDMActions.FinishStageMdmLoadingProgression),
    withLatestFrom(this._store$),
    tap(([action, storeState]) => {
        if (storeState.mdm.progress === 0) {
          this.spinnerService.hide('titled');
        }
      }
    )
  ), {dispatch: false});

  constructor(
    private _service: DictionaryService,
    private apiMdmService: ApiMdmService,
    private _actions$: Actions,
    private _store$: Store<IAppState>,
    private messageService: MessageService,
    private translateService: TranslateService,
    private loggerService: LoggerService,
    private spinnerService: SpinnerService
  ) {

  }
}
